import axios from 'axios';
import API_CONFIG from '../config/api';

// Get auth headers with token
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};

// Interface for message center data
export interface MessageCenterData {
  _id: string;
  messageCenter: {
    MX1: string;
    MX2: string;
    MX3: string;
    MX4: string;
    MX5: string;
    MX6: string;
    MX7: string;
    MX8: string;
    MX9: string;
    MX10: string;
  };
  smsMessages: {
    [key: string]: {
      title: string;
      content: string;
    };
  };
  emailMessages: {
    [key: string]: {
      title: string;
      subject: string;
      content: string;
    };
  };
  createdAt: string;
  updatedAt: string;
}

/**
 * Get all messages (public endpoint for reading)
 */
export const getMessages = async () => {
  try {
    const response = await axios.get(
      API_CONFIG.getUrl('messages/public'),
      getAuthHeaders()
    );
    
    return {
      success: response.data.success,
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {

    throw error;
  }
};

/**
 * Get all messages (admin endpoint for management)
 */
export const getMessagesAdmin = async () => {
  try {
    const response = await axios.get(
      API_CONFIG.getUrl('admin/messages'),
      getAuthHeaders()
    );
    
    return {
      success: response.data.success,
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {

    throw error;
  }
};

/**
 * Update messages
 */
export const updateMessages = async (data: {
  messageCenter?: { [key: string]: string };
  smsMessages?: { [key: string]: { content: string } };
  emailMessages?: { [key: string]: { subject?: string; content?: string } };
}) => {
  try {
    const response = await axios.put(
      API_CONFIG.getUrl('admin/messages'),
      data,
      getAuthHeaders()
    );
    
    return {
      success: response.data.success,
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {

    throw error;
  }
};

/**
 * Reset messages to default
 */
export const resetMessages = async () => {
  try {
    const response = await axios.post(
      API_CONFIG.getUrl('admin/messages/reset'),
      {},
      getAuthHeaders()
    );
    
    return {
      success: response.data.success,
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {

    throw error;
  }
}; 